module.exports = __webpack_public_path__ + "media/club_deals/strategies_photo-5fd271e9.webp";